const APP_ENV = import.meta.env.VITE_ENV;

if (!APP_ENV) {
  throw new Error('[env] VITE_ENV no está definida. Revisa el fichero .env correspondiente.');
}

export const isLocal = APP_ENV === 'local';
export const isPreproduction = APP_ENV === 'preproduction';
export const isProduction = APP_ENV === 'production';

export const DPX_URL = isProduction ? 'https://dpx.iberia.es/' : 'https://dpxpre.iberia.es/';
